import React, { useEffect, useState } from 'react'
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { useDisclosure } from '@chakra-ui/react';
const MenuBar = ({ isOpen }) => {
    const [showMenu, setShowMenu] = useState(isOpen);
    const [selectedLink, setSelectedLink] = useState('DashHome');
    const navigate = useNavigate();

    useEffect(() => {
        setShowMenu(isOpen); // update state when prop changes
    }, [isOpen])

    const handleToggleClick = () => {
        setShowMenu(false);
    }

    const handleClick = async(link, path) => {
         setSelectedLink(link);
        navigate(path); 
    }
    useEffect(() => {
      }, [selectedLink]);

    return ( 
        <div>
            <div>
                {showMenu ?
                    <div
                        className={`fixed z-10 inset-y-0 lg:hidden left-0 w-64 bg-white text-black transition-transform duration-300 transform `}
                    >
                        <div className="flex  justify-end pr-5 pt-3">
                            <button className="text-gray-500 hover:text-gray-700" onClick={handleToggleClick}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className=" p-4 mt-4">
                            <Link
                                className={`block pl-3 py-2 text-lg ${selectedLink === 'home' ? 'bg-gray-300' : ''
                                    }`}
                                to={"/employer-dashboard/"}
                                onClick={() => handleClick('home')}
                            >
                                DashHome
                            </Link>
                            <Link
                                className={`block pl-3 py-2 text-lg ${selectedLink === 'news' ? 'bg-gray-300' : ''
                                    }`}
                                to={"/employer-dashboard/manage-jobs"}
                                onClick={() => handleClick('news')}
                            >
                                manage-jobs
                            </Link>
                            <Link
                                className={`block pl-3 py-2 text-lg ${selectedLink === 'contact' ? 'bg-gray-300' : ''
                                    }`}
                                to={"/employer-dashboard/contact"}
                                onClick={() => handleClick('contact')}
                            >
                                Contact
                            </Link>

                            <Link
                                className={`block pl-3 py-2 text-lg ${selectedLink === 'contact' ? 'bg-gray-300' : ''
                                    }`}
                                to={"/employer-dashboard/appliedJobs"} 
                                onClick={() => handleClick('Applied-jobs')}
                            >
                                Applied Jobs
                            </Link>

                            <Link
                                className={`block pl-3 py-2 text-lg ${selectedLink === 'contact' ? 'bg-gray-300' : ''
                                    }`}
                                    to="/employer-dashboard/sresume" 
                                    onClick={() => handleClick('Sresume')}
                            >
                                Shortlisted Resumes
                            </Link>
                            
                            <Link
                                className={`block pl-3 py-2 text-lg ${selectedLink === 'edit-feedback' ? 'bg-gray-300' : ''
                                    }`}
                                to="/employer-dashboard/edit-feedback"
                                onClick={() => handleClick('edit-feedback')}
                            >
                                Edit Feedback
                            </Link>
                            
                        </div>
                    </div>
                    : null}
            </div>

        </div>

    );
};


export default MenuBar
